import { Component, OnInit } from '@angular/core';
import { Rol } from 'src/app/shared/models/rol.model';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { RolListService } from './rol-list.service';
import { RolCreateModalComponent } from '../rol-create-modal/rol-create-modal.component';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Response } from 'src/app/shared/models/response.model';

@Component({
  selector: 'app-rol-list',
  templateUrl: './rol-list.component.html',
  styleUrls: ['./rol-list.component.scss']
})
export class RolListComponent implements OnInit {

  roles: Rol[];
  modalOptions: NgbModalOptions;

  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription: Subscription = null;

  constructor(private rolListService: RolListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getRoles();
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription   !== null) { this.editSubscription.unsubscribe(); }
  }

  /**
   * Get stock list
   */
  getRoles() {
    this.spinner.show();

    this.getAllSubscription = this.rolListService.resolveRoles(this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
      this.roles           = result.items;
      this.paginationTotal = result.total;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error(error);
    });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(RolCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {

      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.rolListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getRoles();
      }, (error) => {
        this.spinner.hide();
        this.toastr.info(error);
        console.error('Error in rol created', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param rol
   */
  onEdit(rol: Rol): void {
    const modalRef = this.modalService.open(RolCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.rol = rol;
    modalRef.result.then((data) => {

      this.spinner.show();
      this.editSubscription = this.rolListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getRoles();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.info(error);
        console.error('Error in rol modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteSubscription = this.rolListService.delete(id).subscribe(r => {
          this.roles.splice(index, 1);
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.info(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

    /**
   * 
   * @param term 
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getRoles();
  }

  /**
   * 
   */
  onPageChange() {
    this.getRoles();
  }
}
